export const heroData = {
    title: 'Crypto Trading Bots',
    //text: 'Boom Bots are onchain crypto trading and investing bots.<br/>Deploy your bot and stack chips effortlessly.',
    text: 'Boom Bots are onchain crypto trading and investing bots.<br/>Coming to Blast Q1 2024.',
    buttons:[

            {
                text: 'Create Bot',
                class: 'white plausible-event-name=Explore_Button--Homepage-Hero',
                type: 'external',
                url: 'https://app.boombots.xyz/#/create'
            },
            {
                text: 'View Bots',
                class: 'simple plausible-event-name=Build_Modular_Button--Homepage-Hero',
                type: 'external',
                url: 'https://app.boombots.xyz/#/bots'
            }

        ]
}
